// extracted by mini-css-extract-plugin
export default {"defaultFontFamily":"\"Plus Jakarta Sans\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Fira Sans\",\"Droid Sans\",\"Helvetica Neue\",sans-serif"};